export const LOAD_BINS_LIST = 'LOAD_BINS_LIST';
export const ADD_BIN = 'ADD_BIN';
export const DELETE_BIN = 'DELETE_BIN';
